module.exports = __webpack_public_path__ + "img/banner-1.0dfe8e4b.png";